<template>
  <div class="container" v-loading.fullscreen.lock="loading">
    <el-tabs v-model="activeTabPane" @tab-click="handleClick">
      <el-tab-pane label="所有订单" :name="'all'">
        <listTopFilter :ref="`listTopFilter-all`" @getList="resetPage" orderStatus="all_order"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-all" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-all"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-all" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>

      <el-tab-pane label="待付款" name="0" :lazy="false">
        <listTopFilter :ref="`listTopFilter-0`" @getList="resetPage" orderStatus="waiting_payment"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-0" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-0"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-0" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>

      <el-tab-pane label="待发货" name="2">
        <listTopFilter :ref="`listTopFilter-2`" @getList="resetPage" orderStatus="waiting_to_ship"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-2" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-2"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-2" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>

      <el-tab-pane label="在途中" name="6">
        <listTopFilter :ref="`listTopFilter-6`" @getList="resetPage" orderStatus="in_transit"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-6" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-6"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-6" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>

      <el-tab-pane label="待退款" name="3">
        <listTopFilter :ref="`listTopFilter-3`" @getList="resetPage" orderStatus="Refund&Return"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-3" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-3"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-3" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>
      <el-tab-pane label="异常订单" name="5">
        <listTopFilter :ref="`listTopFilter-5`" @getList="resetPage" orderStatus="order_info_missing"></listTopFilter>
        <!-- <div class="filter">
          <operation ref="operation-5" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
        </div>
        <div class="count f-b">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" ref="columnConfigure-5"></columnConfigure>
        </div>
        <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" ref="orderTable-5" @refresh="getOrderList"></orderTable> -->
      </el-tab-pane>
    </el-tabs>

    <div>
      <div class="filter">
        <operation :ref="'operation-'+this.activeTabPane" :shopOptions="shopOptions" :userOptions="userOptions" @export="dataExport" @change="resetPage" />
      </div>
      <div class="count f-b">
        <div class="f--c">
          <p>
            You have <span class="order-cound">{{ total }}</span> orders
          </p>
          <p style="margin-left: 20px;">
            已付款订单总金额:
            <el-tooltip class="item" effect="dark" :content="`未统计 z.seven0209@gmail.com、lululikeblueberry@gmail.com 这两个账号的订单金额`" placement="top-start">
                <i class="el-icon-warning-outline pointer" style="margin-left: 5px;"></i>
            </el-tooltip>
            $ <span class="order-cound">{{ paidTotalAmount }}</span>
          </p>
        </div>
        <columnConfigure @submit="columnConfigureSubmit" :columnInfo="columnInfo" :ref="'columnConfigure-'+this.activeTabPane"></columnConfigure>
      </div>
      <orderTable :orderList="orderList" @batchOutOfStockSubmit="getOrderList" :ref="'orderTable-'+this.activeTabPane" @refresh="getOrderList"></orderTable>
    </div>

    <div class="footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="pageSizeChange" @current-change="pageChange" />
    </div>

    <!-- 自定义导出对话框 -->
    <el-dialog title="导出" :visible.sync="visible" width="1280px" :before-close="close">
      <div class="export-box">
        <div class="not-checked">
          <div class="tips">勾选区</div>
          <el-tabs v-model="exportActiveTabPane">
            <el-tab-pane label="订单信息" name="order">
              <div class="checkout-all">
                <el-checkbox :indeterminate="orderIsIndeterminate" v-model="orderCheckAll" @change="handleOrderCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedOrderList" @change="handleCheckedOrderListChange">
                <el-checkbox v-for="order in orders" :disabled="order.required" :label="order.name" :key="order.code" />
              </el-checkbox-group>
            </el-tab-pane>

            <el-tab-pane label="商品信息" name="goods">
              <div class="checkout-all">
                <el-checkbox :indeterminate="goodsIsIndeterminate" v-model="goodsCheckAll" @change="handleGoodsCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedGoodsList" @change="handleCheckedGoodsListChange">
                <el-checkbox v-for="good in goods" :disabled="good.required" :label="good.name" :key="good.code" />
              </el-checkbox-group>
            </el-tab-pane>

            <el-tab-pane label="地址信息" name="address">
              <div class="checkout-all">
                <el-checkbox :indeterminate="addressIsIndeterminate" v-model="addressCheckAll" @change="handleAddressCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedAddressList" @change="handleCheckedAddressListChange">
                <el-checkbox v-for="addres in address" :disabled="addres.required" :label="addres.name" :key="addres.code" />
              </el-checkbox-group>
            </el-tab-pane>

            <el-tab-pane label="金额信息" name="money">
              <div class="checkout-all">
                <el-checkbox :indeterminate="moneysIsIndeterminate" v-model="moneysCheckAll" @change="handleMoneysCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedMoneysList" @change="handleCheckedMoneysListChange">
                <el-checkbox v-for="money in moneys" :disabled="money.required" :label="money.name" :key="money.code" />
              </el-checkbox-group>
            </el-tab-pane>

            <el-tab-pane label="包裹信息" name="pack">
              <div class="checkout-all">
                <el-checkbox :indeterminate="packIsIndeterminate" v-model="packCheckAll" @change="handlePackCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedPackList" @change="handleCheckedPackListChange">
                <el-checkbox v-for="pack in pack" :disabled="pack.required" :label="pack.name" :key="pack.code" />
              </el-checkbox-group>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="checked">
          <div class="tips">
            已选区 <span class="text">{{ selected.length }}</span>
          </div>
          <ul id="checked-drag" class="checked-group">
            <li v-for="item in selected" :key="item.code" :data-id="item.code" class="checked-group-item">
              <span>{{ item.name }}</span>
              <i v-if="!item.required" class="el-icon-close" @click="() => removeSelectedCheckboxItem(item.name)" />
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button type="primary" size="medium" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { replaceStr } from '@/utils'
import { Sortable } from 'sortablejs'
// import OrderItem from './components/OrderItem.vue'
import Operation from './components/Operation.vue'
// import BatchSearch from '@/components/BatchSearch.vue'
// import PlatformCascader from '@/components/PlatformCascader.vue'
import listTopFilter from './components/listTopFilter.vue'
import columnConfigure from './components/columnConfigure.vue'

import orderTable from './components/orderTable.vue'
import moment from 'moment'

const isArrayAndNonEmpty = (data) => Array.isArray(data) && data.length > 0

let parameter = {
  status: [], // 订单状态（发送前转换为逗号拼接的字符串）
  emails: [], // 邮箱（发送前转换为逗号拼接的字符串）
  date: [], // 开始和结束时间（发送前需删除改字段）
  purchaseDateAt: undefined, // 开始日期
  purchaseDateTo: undefined, // 结束日期

  searchArray: undefined, // 搜索关键字

  storeIds: [], // 店铺ID（发送前转换为逗号拼接的字符串）
  pageSize: 20, // 每页显示条数
  pageNumber: 1, // 当前页
  storeGroups: [], // 分组
  orderTimeType: 0
}

export default {
  name: 'orders_all-orders', 
  components: {
    // BatchSearch,
    // PlatformCascader,
    // OrderItem,
    Operation,
    listTopFilter,
    orderTable,
    columnConfigure
  },
  data() {
    return {
      activeTabPane: 'all', // 当前激活的tab

      parameter: { ...parameter }, // 订单列表请求参数
      total: 0, // 分页总条数
      paidTotalAmount: 0, //已支付订单总金额
      loading: false, // 列表的加载状态
      orderList: [], // 订单列表数据

      orderIdOption: [
        { label: 'SPU', value: 3 },
        { label: 'SKU', value: 1 },
        { label: 'Order Id', value: 0 },
        { label: 'Store Order ID', value: 2 }
      ],

      shopOptions: [
        {
          value: 'zhinan',
          label: '指南',
          children: [
            {
              value: 'shejiyuanze',
              label: '设计原则'
            }
          ]
        }
      ], // 店铺级联选择器下拉选项

      userParameter: {
        email: undefined, // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: []
      }, // 用户下拉框请求参数
      selectLoading: false,
      userOptions: [], // 用户下拉框数据

      visible: false, // 自定义导出对话框 - 是否显示对话框
      exportActiveTabPane: 'order', // 自定义导出对话框 - Tabs当前激活项

      // 导出字段中的英文标识对应关系
      correspondence: [],
      // 所有可导出的字段
      exportFields: [],
      selectedFieldsId: undefined,

      // 自定义导出对话框 - 订单信息
      orderCheckAll: false, // 是否全选
      checkedOrderList: [], // 当前已选项
      orders: [], // 复选框数据源
      orderIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 商品信息
      goodsCheckAll: false, // 是否全选
      checkedGoodsList: [], // 当前已选项
      goods: [], // 复选框数据源
      goodsIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 地址信息
      addressCheckAll: false, // 是否全选
      checkedAddressList: [], // 当前已选项
      address: [], // 复选框数据源
      addressIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 金额信息
      moneysCheckAll: false, // 是否全选
      checkedMoneysList: [], // 当前已选项
      moneys: [], // 复选框数据源
      moneysIsIndeterminate: false, // 全选按钮的半选中样式

      // 自定义导出对话框 - 包裹信息
      packCheckAll: false, // 是否全选
      checkedPackList: [], // 当前已选项
      pack: [], // 复选框数据源
      packIsIndeterminate: false, // 全选按钮的半选中样式


      selected: [], // 所有已选项
      showColumns: [],
      columnInfo: {}
    }
  },
  created() {
    this.$store.dispatch('getPlatFormList')
    this.getBehaviorConfig()
  },
  mounted() {
    this.$nextTick(() => {
      this.getStorageParams().then(() => {
        this.$refs[`operation-${this.activeTabPane}`].getUserOptions()
        this.getOrderList()
      })
    })
  },
  activated() {
    this.getOrderList()
  },
  watch: {
    checkedOrderList(value) {
      this.setSelected(value, 'orders')
    },
    checkedGoodsList(value) {
      this.setSelected(value, 'goods')
    },
    checkedAddressList(value) {
      this.setSelected(value, 'address')
    },
    checkedMoneysList(value) {
      this.setSelected(value, 'moneys')
    },
    checkedPackList(value) {
      this.setSelected(value, 'pack')
    }
  },
  methods: {
    submit() {
      this.getOrderList(false)
    },
    // 获取商品列表
    getOrderList() {
      try {
        this.$nextTick( async() => {
          this.loading = true
          const statusParams = this.$refs[`listTopFilter-${this.activeTabPane}`].getParams()
          const filterParams = this.$refs[`operation-${this.activeTabPane}`].getParams()
          const newParameter = { ...this.parameter, ...filterParams , ...statusParams}
          this.$store.commit('setState', { key: 'orderGetListParams', value: this.parameter })
          let { data } = await API.getOrderList(newParameter)
          this.total = data.total
          this.paidTotalAmount = data.paidTotalAmount
          this.orderList = data.list
          this.loading = false
          Array.from(document.querySelectorAll('.table')).forEach((el) => {
            el.scrollTop = 0
          })
        })
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
    },
    resetPage() {
      this.parameter.pageNumber = 1
      this.getOrderList()
    },

    /**
     * API 获取可导出字段的列表
     */
    async getPublicSelectData() {
      // let obj = {
      //   orderInfo: [], // 订单信息
      //   productInfo: [], // 商品信息
      //   addressInfo: [], // 地址信息
      //   amountInfo: [] // 金额信息
      //   packInfo: [] // 包裹信息
      // }
      try {
        let { data } = await API.getPublicSelectData({ type: 10, param: undefined })
        let { data: selectedFields } = await API.getExportFieldRecords(2)
        if (selectedFields) {
          this.selectedFieldsId = selectedFields.id
          selectedFields = JSON.parse(selectedFields.content)
        }
        if (data) {
          this.exportFields = data
          data.forEach((item) => {
            this.correspondence.push(item.fields)
            switch (item.name) {
              case '订单信息':
                if (item.fields && item.fields.length) {
                  this.orders = item.fields
                  if (selectedFields) {
                    this.checkedOrderList = [...selectedFields.orderInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedOrderList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedOrderList.length === item.fields.length) {
                    this.orderCheckAll = true
                    this.orderIsIndeterminate = false
                  }
                  if (this.checkedOrderList.length > 0 && this.checkedOrderList.length < item.fields.length) {
                    this.orderCheckAll = false
                    this.orderIsIndeterminate = true
                  }
                } else {
                  this.orders = []
                }
                break
              case '商品信息':
                if (item.fields && item.fields.length) {
                  this.goods = item.fields
                  if (selectedFields) {
                    this.checkedGoodsList = [...selectedFields.productInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedGoodsList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedGoodsList.length === item.fields.length) {
                    this.goodsCheckAll = true
                    this.goodsIsIndeterminate = false
                  }
                  if (this.checkedGoodsList.length > 0 && this.checkedGoodsList.length < item.fields.length) {
                    this.goodsCheckAll = false
                    this.goodsIsIndeterminate = true
                  }
                } else {
                  this.goods = []
                }
                break
              case '地址信息':
                this.address = item.fields
                if (item.fields && item.fields.length) {
                  this.address = item.fields
                  if (selectedFields) {
                    this.checkedAddressList = [...selectedFields.addressInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedAddressList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedAddressList.length === item.fields.length) {
                    this.addressCheckAll = true
                    this.addressIsIndeterminate = false
                  }
                  if (this.checkedAddressList.length > 0 && this.checkedAddressList.length < item.fields.length) {
                    this.addressCheckAll = false
                    this.addressIsIndeterminate = true
                  }
                } else {
                  this.address = []
                }
                break
              case '金额信息':
                this.moneys = item.fields
                if (item.fields && item.fields.length) {
                  this.moneys = item.fields
                  if (selectedFields) {
                    this.checkedMoneysList = [...selectedFields.amountInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedMoneysList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedMoneysList.length === item.fields.length) {
                    this.moneysCheckAll = true
                    this.moneysIsIndeterminate = false
                  }
                  if (this.checkedMoneysList.length > 0 && this.checkedMoneysList.length < item.fields.length) {
                    this.moneysCheckAll = false
                    this.moneysIsIndeterminate = true
                  }
                } else {
                  this.moneys = []
                }
                break
              case '包裹信息':
                this.pack = item.fields
                if (item.fields && item.fields.length) {
                  this.pack = item.fields
                  if (selectedFields) {
                    this.checkedPackList = selectedFields.packInfo ? [...selectedFields.packInfo] : []
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedPackList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedPackList.length === item.fields.length) {
                    this.packCheckAll = true
                    this.packIsIndeterminate = false
                  }
                  if (this.checkedPackList.length > 0 && this.checkedPackList.length < item.fields.length) {
                    this.packCheckAll = false
                    this.packIsIndeterminate = true
                  }
                } else {
                  this.pack = []
                }
                break
            }
          })
          this.correspondence = this.correspondence.flat()
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },

    async getUserOptions() {
      this.selectLoading = true
      let result = await API.getUserOptions(this.userParameter)
      this.userOptions = result.data.list
      this.selectLoading = false
    },

    // 点击tabs栏的回调
    handleClick(tab) {
      this.activeTabPane = tab.name
      this.parameter = { ...parameter, pageSize: this.parameter.pageSize }
      this.total = 0
      this.getOrderList()
      this.$nextTick(() => {
        let columnInfoContent = this.columnInfo.content ? JSON.parse(this.columnInfo.content) : ['总金额', '付款时间', '创建时间', '客户名称', '客户邮箱', '订单状态']
        this.$refs[`columnConfigure-${this.activeTabPane}`].setShowColumn(columnInfoContent)
        this.$refs[`orderTable-${this.activeTabPane}`].changeShowColumns(columnInfoContent)
        this.$refs[`operation-${this.activeTabPane}`].getUserOptions()
      })
    },

    //分组搜索
    getList(value) {
      this.parameter.storeGroups = value
      this.getOrderList()
    },

    // 当前页改变时会触发
    pageChange(page) {
      this.parameter.pageNumber = page
      this.getOrderList(false)
    },

    pageSizeChange(size) {
      this.parameter.pageNumber = 1
      this.parameter.pageSize = size
      this.getOrderList(false)
    },

    getStorageParams() {
      return new Promise((resolve) => {
        const { pageNumber = 1, pageSize = 20, ...params } = this.$store.state.orderGetListParams
        this.parameter.pageNumber = pageNumber
        this.parameter.pageSize = pageSize
        if (this.$route.query.searchArray) params.searchArray = this.$route.query.searchArray.join(',')
        this.$refs[`operation-${this.activeTabPane}`].getDefaultValue(params)
        resolve()
      })
    },

    dataExport() {
      this.visible = true
      this.drag()
      this.getPublicSelectData()

      // 以下为旧需求的代码
      // let newParameter = { ...this.parameter }
      // if (newParameter.platformCode && typeof newParameter.platformCode === 'string') newParameter.platformCode = [newParameter.platformCode]
      // newParameter.status = isArrayAndNonEmpty(newParameter.status) ? newParameter.status.join(',') : undefined
      // newParameter.emails = isArrayAndNonEmpty(newParameter.emails) ? newParameter.emails.join(',') : undefined
      // newParameter.platformCode = isArrayAndNonEmpty(newParameter.platformCode) ? newParameter.platformCode.join(',') : undefined
      // newParameter.storeId = isArrayAndNonEmpty(newParameter.storeId) ? newParameter.storeId.join(',') : undefined
      // newParameter.users = isArrayAndNonEmpty(newParameter.users) ? newParameter.users.join(',') : undefined
      // newParameter.purchaseDateAt = isArrayAndNonEmpty(newParameter.date) ? newParameter.date[0].replace(' ', '') : undefined
      // newParameter.purchaseDateTo = isArrayAndNonEmpty(newParameter.date) ? newParameter.date[1].replace(' ', '') : undefined

      // delete newParameter.date
      // const params = {
      //   fileType: 2,
      //   taskType: 10,
      //   condition: JSON.stringify(newParameter)
      // }
      // API.dashboardImportExportFile(params).then(() => {
      //   this.$message.success('操作成功，请到导入导出管理查看')
      // })
    },

    /**
     * 拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
    drag() {
      this.$nextTick(() => {
        let element = document.getElementById('checked-drag')
        if (element) {
          new Sortable(element, {
            handle: '.checked-group-item',
            draggable: '.checked-group-item',
            animation: 500,
            dataIdAttr: 'data-id'
          })
        }
      })
    },

    /**
     * 自定义导出对话框 - 订单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleOrderCheckAllChange(value) {
      if (value) {
        this.checkedOrderList = this.orders.map((item) => item.name)
      } else {
        this.checkedOrderList = []
        this.orders.forEach((item) => {
          if (item.required) {
            this.checkedOrderList.push(item.name)
          }
        })
      }
      if (this.checkedOrderList.length && this.checkedOrderList.length < this.orders.length) {
        this.orderIsIndeterminate = true
      } else {
        this.orderIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 订单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedOrderListChange(value) {
      let checkedCount = value.length
      this.orderCheckAll = checkedCount === this.orders.length
      this.orderIsIndeterminate = checkedCount > 0 && checkedCount < this.orders.length
    },

    /**
     * 自定义导出对话框 - 商品信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleGoodsCheckAllChange(value) {
      if (value) {
        this.checkedGoodsList = this.goods.map((item) => item.name)
      } else {
        this.checkedGoodsList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedGoodsList.push(item.name)
          }
        })
      }
      if (this.checkedGoodsList.length && this.checkedGoodsList.length < this.goods.length) {
        this.goodsIsIndeterminate = true
      } else {
        this.goodsIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 商品信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedGoodsListChange(value) {
      let checkedCount = value.length
      this.goodsCheckAll = checkedCount === this.goods.length
      this.goodsIsIndeterminate = checkedCount > 0 && checkedCount < this.goods.length
    },

    /**
     * 自定义导出对话框 - 地址信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleAddressCheckAllChange(value) {
      if (value) {
        this.checkedAddressList = this.address.map((item) => item.name)
      } else {
        this.checkedAddressList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedAddressList.push(item.name)
          }
        })
      }
      if (this.checkedAddressList.length && this.checkedAddressList.length < this.address.length) {
        this.addressIsIndeterminate = true
      } else {
        this.addressIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 地址信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedAddressListChange(value) {
      let checkedCount = value.length
      this.addressCheckAll = checkedCount === this.address.length
      this.addressIsIndeterminate = checkedCount > 0 && checkedCount < this.address.length
    },

    /**
     * 自定义导出对话框 - 金额信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleMoneysCheckAllChange(value) {
      if (value) {
        this.checkedMoneysList = this.moneys.map((item) => item.name)
      } else {
        this.checkedMoneysList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedMoneysList.push(item.name)
          }
        })
      }
      if (this.checkedMoneysList.length && this.checkedMoneysList.length < this.moneys.length) {
        this.moneysIsIndeterminate = true
      } else {
        this.moneysIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 金额信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedMoneysListChange(value) {
      let checkedCount = value.length
      this.moneysCheckAll = checkedCount === this.moneys.length
      this.moneysIsIndeterminate = checkedCount > 0 && checkedCount < this.moneys.length
    },

    /**
     * 自定义导出对话框 - 金额信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handlePackCheckAllChange(value) {
      if (value) {
        this.checkedPackList = this.pack.map((item) => item.name)
      } else {
        this.checkedPackList = []
        this.goods.forEach((item) => {
          if (item.required) {
            this.checkedPackList.push(item.name)
          }
        })
      }
      if (this.checkedPackList.length && this.checkedPackList.length < this.pack.length) {
        this.packIsIndeterminate = true
      } else {
        this.packIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 包裹信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedPackListChange(value) {
      let checkedCount = value.length
      this.packCheckAll = checkedCount === this.pack.length
      this.packIsIndeterminate = checkedCount > 0 && checkedCount < this.pack.length
    },

    /**
     * 自定义导出对话框 - 设置已勾选项
     * @param {Array} value 已勾选的复选框数组
     * @param {String} original 可选项数组
     */
    setSelected(value, original) {
      let selected = []
      let unchecked = []
      this[original].forEach((item) => {
        if (value.includes(item.name)) {
          selected.push(item.name)
        } else {
          unchecked.push(item.name)
        }
      })
      unchecked.forEach((item) => {
        this.selected.forEach((inside, index) => {
          if (item === inside.name) {
            this.selected.splice(index, 1)
          }
        })
      })
      this.correspondence.forEach((item) => {
        if (selected.includes(item.name)) {
          this.selected = Array.from(new Set([...this.selected, item]))
        }
      })
    },

    /**
     * 自定义导出对话框 - 删除某个已选的复选框
     * @param {String} value 当前删除的复选框的值
     */
    removeSelectedCheckboxItem(value) {
      if (this.checkedOrderList.includes(value)) {
        this.checkedOrderList = this.checkedOrderList.filter((item) => item !== value)
        this.handleCheckedOrderListChange(this.checkedOrderList)
      }
      if (this.checkedGoodsList.includes(value)) {
        this.checkedGoodsList = this.checkedGoodsList.filter((item) => item !== value)
        this.handleCheckedGoodsListChange(this.checkedGoodsList)
      }
      if (this.checkedAddressList.includes(value)) {
        this.checkedAddressList = this.checkedAddressList.filter((item) => item !== value)
        this.handleCheckedAddressListChange(this.checkedAddressList)
      }
      if (this.checkedMoneysList.includes(value)) {
        this.checkedMoneysList = this.checkedMoneysList.filter((item) => item !== value)
        this.handleCheckedMoneysListChange(this.checkedMoneysList)
      }
      this.selected = this.selected.filter((item) => item.name !== value)
    },

    /**
     * 自定义导出 - 对话框保存按钮的事件
     */
    save() {
      if (this.selected.length === 0) {
        this.$message.warning('请选择需要导出的字段!')
        return
      }
      const statusParams = this.$refs[`listTopFilter-${this.activeTabPane}`].getParams()
      const filterParams = this.$refs[`operation-${this.activeTabPane}`].getParams()
      const newParameter = { ...this.parameter, ...statusParams, ...filterParams }

      let ul = document.getElementById('checked-drag')
      let selected = []
      Array.from(ul.children).forEach((li) => {
        selected.push(li.getAttribute('data-id'))
      })

      const params = {
        fileType: 2,
        taskType: 15,
        condition: JSON.stringify({
          searchContent: newParameter,
          sortFields: [...selected]
        })
      }

      let obj = {
        orderInfo: [], // 订单信息
        productInfo: [], // 商品信息
        addressInfo: [], // 地址信息
        amountInfo: [], // 金额信息
        packInfo: [] // 包裹信息
      }

      this.exportFields.forEach((item) => {
        if (item.code === 'order_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.orderInfo.push(field.name)
            }
          })
        }
        if (item.code === 'product_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.productInfo.push(field.name)
            }
          })
        }
        if (item.code === 'address_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.addressInfo.push(field.name)
            }
          })
        }
        if (item.code === 'amount_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.amountInfo.push(field.name)
            }
          })
        }
        if (item.code === 'pack_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.packInfo.push(field.name)
            }
          })
        }
      })

      API.setExportFieldRecords({ id: this.selectedFieldsId ? this.selectedFieldsId : undefined, type: 2, content: JSON.stringify(obj) })
        .then(() => {})
        .catch(() => {})

      API.dashboardImportExportFile(params)
        .then(() => {
          this.close()
          this.$message.success('操作成功，请到导入导出管理查看')
        })
        .catch(() => {
          this.$message.error('导出失败，请重新操作')
        })
    },

    /**
     * 自定义导出 - 对话框关闭的事件
     */
    close() {
      this.visible = false
      this.clear()
    },

    /**
     * 自定义导出 - 负责清除数据方法
     */
    clear() {
      this.correspondence = []
      this.orderCheckAll = false
      this.checkedOrderList = []
      this.orderIsIndeterminate = false
      this.goodsCheckAll = false
      this.checkedGoodsList = []
      this.goodsIsIndeterminate = false
      this.addressCheckAll = false
      this.checkedAddressList = []
      this.addressIsIndeterminate = false
      this.moneysCheckAll = false
      this.checkedMoneysList = []
      this.moneysIsIndeterminate = false
      this.selected = []
    },
    columnConfigureSubmit(column) {
      this.showColumns = column
      this.columnInfo.content = JSON.stringify(column)
      this.$refs[`orderTable-${this.activeTabPane}`].changeShowColumns(column)
    },
    getBehaviorConfig() {
      API.getBehaviorConfig(1).then((res) => {
        if (!res.data) return
        this.columnInfo = res.data
        this.$refs[`columnConfigure-${this.activeTabPane}`].setShowColumn(JSON.parse(res.data.content))
        this.$refs[`orderTable-${this.activeTabPane}`].changeShowColumns(JSON.parse(res.data.content))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  font-size: 14px;
  padding: 12px;
  background-color: #fff;
  .el-tabs {
    // height: calc(100% - 40px);
    /deep/.el-tabs__content {
      height: calc(100% - 60px);
      .el-tab-pane {
        .filter {
          margin-bottom: 15px;
          .search-input {
            width: 428px;
            .search-select {
              width: 145px;
            }
          }
        }
      }
    }
  }
  .count {
    margin-top: 6px;
    align-items: center;
    .order-cound {
      color: #99c41c;
      font-size: 16px;
    }
  }
  .table {
    overflow: auto;
    height: calc(100% - 51px - 26px - 12px);
  }
  .footer {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: flex-end;
  }

  .default-maggin-left {
    margin-left: 15px;
  }

  /deep/.el-input-group__prepend {
    background-color: #fff !important;
  }
  .rightBorderNone {
    /deep/.el-input__inner {
      border-right: 0 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      &:focus,
      &:active,
      &:visited,
      &:focus {
        border-color: #dcdfe6 !important;
      }
    }
  }

  /deep/.el-date-editor {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .export-box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #e9e9e9;
    .not-checked,
    .checked {
      padding: 10px;
      .tips {
        line-height: 18px;
        margin-bottom: 10px;
        .text {
          color: #99c41c;
          font-weight: 700;
        }
      }
    }

    .not-checked {
      flex: 9;
      border-right: 1px solid #e9e9e9;
      /deep/.el-tabs__content {
        .el-tab-pane {
          overflow: auto;
        }
      }
      .checkout-all {
        margin-bottom: 10px;
      }
      .el-checkbox-group {
        .el-checkbox {
          width: 30%;
          margin-right: 22px !important;
          margin-bottom: 6px !important;
        }
      }
    }

    .checked {
      flex: 3;
      .checked-group {
        width: 100%;
        min-height: 280px;
        max-height: 480px;
        height: calc(100% - 28px);
        overflow-y: auto;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        .checked-group-item {
          display: flex;
          width: 100%;
          line-height: 28px;
          padding: 5px 8px;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #dcdfe6;
          user-select: none;
          cursor: move;
          span {
            max-width: 258px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          i {
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
